/**
 * Export module
*/
import {
    login as rlogin
} from '../../requests/loader';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Device from "../../devices/device";

const siloHostnameOTT = "aaf-cvideo-tv.clarovideo.net";
const siloHostnameIPTV = "aaf-cvideo-stb.clarovideo.net";
const siloHostnameSEIOTT = "aaf-cvideo-stb-robotics.clarovideo.net";

const getHostname = function() {
    return window.location && window.location.hostname;
};

const isLocalIP = function() {
    const hostname = getHostname();
    if(!hostname) return true; // Si no tiene hostname, es muy seguro que este en una máquina local

    return !isNaN(hostname.split('.').join(""));
};

const isLocalAddress = function() {
    return getHostname() === "localhost" 
        || getHostname() === "127.0.0.1" 
        || getHostname().indexOf('preprod') !== -1 
        || getHostname().indexOf('test') !== -1 
        || window.location.hostname === "" ;
};

const isLocalhost = function() {
    return isLocalAddress() || isLocalIP();
}

const getUserHash = function() {
    return DeviceStorage.getItem('user_hash') || null;
};

const getUserHKS = function() {
    return DeviceStorage.getItem('HKS') || null;
};

const getURLParamByName = function(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null; // param does not exist
    if (!results[2]) return ''; // empty param

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const redirectCorrectSilo = function(user_hash = null, hks = null, silo) {
    const siloOTTURL = `${window.location.protocol}//${silo}`;
    const redirectURL = user_hash ? `${siloOTTURL}/?cvuh=${user_hash}&ks=${hks}` : siloOTTURL;
    console.log('[SILO] redirect to: ' + redirectURL);
    window.location.href = redirectURL; 
};

const clearCVStorage = function() {
    DeviceStorage.clear();    
};

const setStorageItem = function(item, value) {
    DeviceStorage.setItem(item, value);    
};

const getOTTDevice = function() {
    const device = Device.getDevice();    
    let platform = device.getPlatform();
    if(platform === 'android') {
        if(typeof device.getSubplatform === 'function') {
            if(device.getSubplatform() === 'stbcoship' || device.getSubplatform() === 'seirobotics') {
                platform = device.getSubplatform();
            }
        }
        // Si es android y no coship, se trata como IPTV, no es OTT
        if(platform === 'android') platform = null;
    }

    return platform;
};

const loginbyUserHash = function(userhash, HKS) {
    // Recupera, i.e.: http://mfwktv2samsung-api.clarovideo.net
    const akamai_mfwk = `${Device.getDevice().getConfig().akamai_mfwk}`;
    console.log('[SILO] loginByUserHash akamai_mwfk: ', akamai_mfwk);
    console.log('[SILO] loginByUserHash user_hash: ', userhash);
    console.log('[SILO] loginByUserHash HKS ', HKS);
    return new Promise((resolve, reject) => {
        rlogin({userhash, HKS}, akamai_mfwk).then((response) => {
            resolve(response);
        }).catch((err) => {
            reject(err);
        });
    } );
};

const getSiloTV = function() {
    return siloHostnameOTT;
};

const getSiloSTB = function() {
    return siloHostnameIPTV;
};

const getSiloSEI = function() {
    return siloHostnameSEIOTT;
};

const isCorrectSiloEndpoint = function(expectedSilo) {   
    return getHostname() === expectedSilo;
};

const siloUtil = {
    getHostname,
    isLocalhost,
    getUserHash,
    getUserHKS,
    getURLParamByName,
    redirectCorrectSilo,
    clearCVStorage,
    setStorageItem,
    loginbyUserHash,
    getOTTDevice,
    getSiloSTB,
    getSiloTV,
    getSiloSEI,
    isCorrectSiloEndpoint
};

export { siloUtil };


// WEBPACK FOOTER //
// ./src/AAF/Silo/siloUtil.js